var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "8px",
    viewBox: "0 0 33 8",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945433 7.16955C0.56726 7.16955 0 6.7922 0 6.41486C0 5.84884 0.189087 5.28282 0.756346 5.28282L31.3884 0C31.9556 0 32.3338 0.188672 32.5229 0.754689C32.712 1.32071 32.3338 1.88672 31.7665 1.88672L0.945433 7.16955C1.13452 7.16955 1.13452 7.16955 0.945433 7.16955Z",
    id: "Path",
    fill: "#000000",
    fillOpacity: 0.8662807,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg74);
export default __webpack_public_path__ + "static/media/74.88493387c82ff74cd5fc3421fbc2e3a7.svg";
export { ForwardRef as ReactComponent };